module.exports = __webpack_public_path__ + "static/media/note.5c9ce119.svg";